import { useQuery } from "react-query";
import http from "infra/http";

function useTiposIndiceMonetario() {
  return useQuery(["/v1/tipos-indice-monetarios"], async () => {
    const { data } = await http.get<{ id: string; nome: string;  }[]>(
      "/v1/tipos-indice-monetarios"
    );

    return data;
  });
}

export default useTiposIndiceMonetario;
